var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-index-bar',{attrs:{"index-list":_vm.indexList}},_vm._l((_vm.modelList),function(item,index){return _c('div',{key:item.modelId,staticClass:"vant-content",attrs:{"id":item.modelId,"align":"center"}},[_c('van-cell',{class:{
        'van-cell': true,
        'van-cell-1': index === _vm.modelList.length - 1
      },on:{"click":function($event){return _vm.chooseCarBrandFn(item)}}},[_vm._v(_vm._s(item.modelName))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }